import { ROUTES_CONFIG } from '@/config/routes.config'
import { Navigate } from 'react-router-dom'

const HomePage = () => {
  return (<Navigate to={ROUTES_CONFIG.AUTH.LOGIN.$buildPath({})}/>)
}

export default HomePage